

























































































































































import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import dayjs from 'dayjs';
import VueMonthlyPicker from 'vue-monthly-picker';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import { mapState } from 'vuex';
import api from '@/libs/api';
import FileIcon from 'mdi-vue/File';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import ReportTable from './OnepayTransTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    FileIcon,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    VueMonthlyPicker,
    Tab,
    SearchIcon,
    ExportIcon,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    ReportTable,
    FormInput,
  },
  computed: mapState(['user']),
})
export default class OnepayTrans extends Vue {
  user!: {
    user: User;
  };

  merchantLoginData: any = this.$store.state.user.user;
  userRole: any = this.merchantLoginData.user_role.role;
  filterParameter = '';

  @Prop({ default: 'default' }) readonly size!: string;
  monthpick = false;
  paymentDate: DateRange = {
    startDate: dayjs().format('YYYY-MM-DD  00:00:00'),
    endDate: dayjs().format('YYYY-MM-DD  00:00:00'),
  }

  arrayFilter = [];
  merchantNamefilter: any = [];
  paymentMethodfilter: any = [];
  datestart = dayjs(Date()).subtract(7, 'day').format('YYYY-MM-DD');
  dateend = dayjs().format('YYYY-MM-DD');
  transStat = [
    { value: 'all', label: 'ALL' },
    { value: 'unpaid', label: 'DECLINED' },
    { value: 'paid', label: 'APPROVED' },
    { value: 'closed', label: 'CANCELLED' },
  ]

  currentChannel = {
    title: 'Credit Card',
    code: 'creditcard',
    path: 'creditcard',
  }

  searchOpen = false;
  showItemprpage = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
  ];

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  selectedMerchants: LabelValue | null = null;
  tagIds: SelectItem[] = []
  channelIds: string[] = []
  vaNumber = '';
  transStatus: LabelValue | null = null;
  paymentMethod: {
    logo: string;
    service_code: string;
    name: string;
    type: string;
    status: 1 | 0;
  } | null = null;

  transReference = '';
  loadingMerchant = false;
  loadingExport = false;
  arraymerge: any = [];

  showitemperpage = '';
  startperiode = '';
  endperiode = '';
  locale = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  channelIdList: string[] = [];
  loadingChannelId = false;

  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  $refs!: {
    report: ReportTable;
  }

  format!: (val: string) => string;

  mounted() {
    // console.log(this.merchantLoginData);
    this.parseParams();
    // this.getListData(1);
    // this.getChannelIds();
  }

  @Watch('$route')
  onRouteChange() {
    // this.getListData(Number(this.$route.query.page.toString()));
    this.parseParams();
  }

  async searchFilter(page: number) {
    /* eslint-disable @typescript-eslint/camelcase */
    this.datestart = dayjs(this.paymentDate.startDate?.toString()).format('YYYY-MM-DD');
    this.dateend = dayjs(this.paymentDate.endDate?.toString()).format('YYYY-MM-DD');

    if (page === 1 && this.$route.query.page) {
      const query = { ...this.$route.query };
      delete query.page;
      this.$router.replace({ query });
    }

    const params = {
      start_date: this.datestart, // dayjs(this.startperiode.toString()).format('YYYY-MM'),
      end_date: this.dateend, // dayjs().format('YYYY-MM-DD'),
      status: this.transStatus !== null ? this.transStatus.value : 'all',
      payment_method: this.paymentMethod !== null ? this.paymentMethod.service_code : 'all',
      merch_id: this.selectedMerchants !== null ? this.selectedMerchants.value : '',
      transaction_number: this.vaNumber !== '' ? this.vaNumber : '',
      transaction_reff: this.transReference !== '' ? this.transReference : '',
      // limit: '5',
    };

    await this.$refs.report.getListData(params, page);
  }

  // async getChannelIds(merchant?: string[]) {
  //   try {
  //     this.loadingChannelId = true;
  //     const { data } = await api.get<ChannelIdResponse>('/transaction/channels', {
  //       params: {
  //         // eslint-disable-next-line @typescript-eslint/camelcase
  //         merchant_code: merchant || undefined,
  //       },
  //     });
  //     this.channelIdList = data.data.map((e) => e.channel_id);
  //     this.loadingChannelId = false;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }

  // @Watch('selectedMerchants')
  // onMerchantChange() {
  //   this.getChannelIds(this.selectedMerchants.map((e) => e.merchant_code));
  // }

  async downloadFile() {
    // console.log(this.merchantLoginData.merchant_id);
    /* eslint-disable @typescript-eslint/camelcase */
    this.datestart = dayjs(this.paymentDate.startDate?.toString()).format('YYYY-MM-DD');
    this.dateend = dayjs(this.paymentDate.endDate?.toString()).format('YYYY-MM-DD');
    let parameterdownload = {};
    if (this.userRole === 'Super Admin') {
      parameterdownload = {
        user_role: 'ADMIN',
        user_group: 'SPRINT',
        start_date: this.datestart,
        end_date: this.dateend,
        status: this.transStatus !== null ? this.transStatus.value : 'all',
        payment_method: this.paymentMethod !== null ? this.paymentMethod.service_code : 'all',
        merch_id: this.selectedMerchants !== null ? this.selectedMerchants.value : '',
        transaction_number: this.vaNumber !== '' ? this.vaNumber : '',
        transaction_reff: this.transReference !== '' ? this.transReference : '',
      };
    } else {
      parameterdownload = {
        user_role: 'MANAGER',
        user_group: 'MERCHANT',
        merch_id: this.merchantLoginData.merchant_id,
        start_date: this.datestart,
        end_date: this.dateend,
        status: this.transStatus !== null ? this.transStatus.value : 'all',
        payment_method: this.paymentMethod !== null ? this.paymentMethod.service_code : 'all',
        transaction_number: this.vaNumber !== '' ? this.vaNumber : '',
        transaction_reff: this.transReference !== '' ? this.transReference : '',
      };
    }
    // console.log(this.datestart);
    // console.log(this.dateend);
    await api.get('/onepay/transaction_download2', {
      params: parameterdownload,
      responseType: 'arraybuffer',
    }).then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'transaction.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  }

  testonClick() {
    alert(this.channelIds);
  }

  async getListData(page: number) {
    const dateNow = new Date();
    dateNow.setMonth(dateNow.getMonth() - 3);
    /* eslint-disable @typescript-eslint/camelcase */
    /* eslint-disable no-plusplus */
    /* eslint prefer-arrow-callback: "error" */
    /* eslint-env es6 */
    if (page === 1 && this.$route.query.page) {
      const query = { ...this.$route.query };
      delete query.page;
      this.$router.replace({ query });
    }

    const { data } = await api.get('/onepay/transaction_filter_data');
    this.merchantNamefilter = data.merchant_data;
    const method = await api.get('listPaymentChannel');
    // console.log('method', method.data);
    // console.log('data', data.service);
    Object.keys(method.data).forEach((key) => {
      this.arraymerge = this.arraymerge.concat(method.data[key]);
    });
    // console.log('arraymerge', this.arraymerge);
    // for (let i = 0; i < Object.keys(method.data.additional_service).length; i++) {
    //   this.arraymerge.push(method.data.additional_service[i]);
    // }
    // for (let i = 0; i < Object.keys(method.data.credit_card).length; i++) {
    //   this.arraymerge.push(method.data.credit_card[i]);
    // }
    // for (let i = 0; i < Object.keys(method.data.e_walet).length; i++) {
    //   this.arraymerge.push(method.data.e_walet[i]);
    // }
    // for (let i = 0; i < Object.keys(method.data.internet_banking).length; i++) {
    //   this.arraymerge.push(method.data.internet_banking[i]);
    // }
    // for (let i = 0; i < Object.keys(method.data.online_installment).length; i++) {
    //   this.arraymerge.push(method.data.online_installment[i]);
    // }
    // for (let i = 0; i < Object.keys(method.data.virtual_account).length; i++) {
    //   this.arraymerge.push(method.data.virtual_account[i]);
    // }

    const compareresult = this.arraymerge.filter((o1: any) => data.service.some(
      (o2: any) => o1.service_code === o2.service_code,
    ));

    this.paymentMethodfilter = compareresult;

    const params = {
      start_date: dayjs(dateNow).format('YYYY-MM-DD'),
      end_date: this.dateend, // dayjs().format('YYYY-MM-DD'),
      status: this.transStatus !== null ? this.transStatus.value : 'all',
      payment_method: this.paymentMethod !== null ? this.paymentMethod.service_code : 'all',
      // limit: '5',
    };
    // console.log(params);
    await this.$refs.report.getListData(params, page);
  }

  async getMerchants(query: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const { data } = await api.get('/merchants', {
        params: {
          name: query,
        },
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getTransaction(isExport = false, page: number) {
    const params = {
      channel: this.currentChannel,
      channelIds: this.channelIds,
    };

    if (isExport) {
      await this.$refs.report.export(params);
    } else {
      await this.$refs.report.getTransaction(params, false, page);
    }
  }

  parseParams() {
    // console.log('role - ', this.$store.state.user.user.user_role.role);
    // console.log('user - ', this.$store.state.user.user);
    const params = this.$route.query;

    if (typeof params.mc === 'string') {
      const merchants = JSON.parse(params.mc).map((e: { c: string; n: string }) => ({
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: e.c,
        merchant_name: e.n,
        /* eslint-enable @typescript-eslint/camelcase */
      }));
      this.selectedMerchants = merchants;
    } else {
      this.selectedMerchants = null;
    }

    if (typeof params.ch === 'string') {
      const channelIds = params.ch.split(',');
      this.channelIds = channelIds;
    } else {
      this.channelIds = [];
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getListData(page);
    // this.getTransaction(false, page);
  }

  search() {
    this.$router.push({
      query: {
        ch: this.channelIds.length === 0 ? undefined : this.channelIds.join(','),
      },
    });
  }

  async exportData() {
    const dateNow = new Date();
    this.loadingExport = true;
    this.selectedMerchants = null;
    this.vaNumber = '';
    this.transStatus = null;
    this.paymentMethod = null;
    this.transReference = '';
    this.paymentDate = {
      startDate: dayjs().format('YYYY-MM-DD  00:00:00'),
      endDate: dayjs().format('YYYY-MM-DD  00:00:00'),
    };
    dateNow.setMonth(dateNow.getMonth() - 3);
    // console.log('start date', dayjs(someDate.setTime(someDate.getTime() - 3*28*24*60*60)).format('YYYY-MM-DD'));
    // await this.getTransaction(true, 1);
    this.loadingExport = false;
    const params = {
      /* eslint-disable @typescript-eslint/camelcase */
      start_date: dayjs(dateNow).format('YYYY-MM-DD'), // dayjs(this.startperiode.toString()).format('YYYY-MM'),
      end_date: this.dateend, // dayjs().format('YYYY-MM-DD'),
      status: 'all',
      payment_method: 'all',
      // limit: '5',
      /* eslint-enable @typescript-eslint/camelcase */
    };
    // console.log(params);
    await this.$refs.report.getListData(params, 1);
  }

  cancel() {
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };
    this.selectedMerchants = null;
    this.tagIds = [];
    this.channelIds = [];

    this.$router.push({
      query: {},
    });
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
